<div class="tw-flex tw-justify-center tw-gap-3">
  @for (index of boxes; track index) {
    <input
      #box
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      class="tw-h-10 tw-w-[38px] tw-rounded-none tw-border-0 tw-border-b-2 tw-border-solid tw-bg-transparent tw-px-0 tw-pb-1 tw-pt-0 tw-text-center tw-font-rubik tw-text-[22px] tw-text-main-text focus:tw-border-b-main-blue focus:tw-outline-none disabled:tw-border-b-main-disabled disabled:tw-text-disabled-font"
      [ngClass]="hasError() ? 'tw-border-b-[#d00000]' : 'tw-border-b-main-text'"
      [disabled]="disabled()"
      [attr.aria-label]="'auth_login.mfa.code_digit_aria' | translate: { n: index + 1 }"
      (input)="handleInput(index, $event)"
      (keydown)="handleKeydown(index, $event)"
      (paste)="handlePaste(index, $event)"
      (blur)="handleBlur()"
    />
  }
</div>
